import { t } from 'i18next'

export const departments = [
  {
    label: t('--roles-administrative', { ns: 'agency' }),
    value: 'ADMINISTRATION',
  },
  {
    label: t('--roles-billing', { ns: 'agency' }),
    value: 'BILLING',
  },
  {
    label: t('--roles-booking', { ns: 'agency' }),
    value: 'BOOKING',
  },
  {
    label: 'Call Center',
    value: 'CALL_CENTER',
  },
  {
    label: t('--roles-commercial', { ns: 'agency' }),
    value: 'COMMERCIAL',
  },
  {
    label: 'Correspondência',
    value: 'CORRESPONDENCE',
  },
  {
    label: t('--roles-events', { ns: 'agency' }),
    value: 'EVENT',
  },
  {
    label: t('--roles-finance', { ns: 'agency' }),
    value: 'FINANCIAL',
  },
  {
    label: 'Fiscal',
    value: 'FISCAL',
  },
  {
    label: t('--roles-main', { ns: 'agency' }),
    value: 'MAIN',
  },
  {
    label: t('--roles-manager', { ns: 'agency' }),
    value: 'MANAGEMENT',
  },
  {
    label: 'Marketing',
    value: 'MARKETING',
  },
  {
    label: t('--roles-rate-manager', { ns: 'agency' }),
    value: 'RATE_MANAGEMENT',
  },
  {
    label: t('--roles-reception', { ns: 'agency' }),
    value: 'RECEPTION',
  },
  {
    label: t('--roles-report', { ns: 'agency' }),
    value: 'REPORT',
  },
  {
    label: t('--roles-sales', { ns: 'agency' }),
    value: 'SALE',
  },
]
